import { graphql } from 'gatsby'

export const sharpFields = graphql`
  fragment imageSharpFields on File {
    childImageSharp {
      large: fluid(maxWidth: 2200) {
        ...GatsbyImageSharpFluid
        presentationWidth
        presentationHeight
      }
      medium: fluid(maxWidth: 800) {
        ...GatsbyImageSharpFluid
        presentationWidth
        presentationHeight
      }
      small: fluid(maxWidth: 400) {
        ...GatsbyImageSharpFluid
        presentationWidth
        presentationHeight
      }
    }
  }
`

export const imagesFields = graphql`
  fragment imageFields on wordpress__wp_media {
    id
    caption
    localFile {
      ...imageSharpFields
    }
  }
`
